import { apiClient } from "@/lib/apiClient";

export const marketingService = {
  async brandContext() { return (await apiClient.get("/marketing/brand-context")).data; },
  async list(params = {}) { return (await apiClient.get("/marketing/content", { params })).data; },
  async calendar(params = {}) { return (await apiClient.get("/marketing/calendar", { params })).data; },
  async get(id) { return (await apiClient.get(`/marketing/content/${id}`)).data.content; },
  async create(p) { return (await apiClient.post("/marketing/content", p)).data.content; },
  async update(id, p) { return (await apiClient.put(`/marketing/content/${id}`, p)).data.content; },
  async setStatus(id, status) { return (await apiClient.post(`/marketing/content/${id}/status`, { status })).data.content; },
  async publish(id) { return (await apiClient.post(`/marketing/content/${id}/publish`)).data.content; },
  async duplicate(id) { return (await apiClient.post(`/marketing/content/${id}/duplicate`)).data.content; },
  async archive(id) { return (await apiClient.post(`/marketing/content/${id}/archive`)).data.content; },
};
